/** Two-way Zoho contacts and accounts sync (M29 P2, CRM-006 proposed): mirror of backend `app/core/constants/zoho_sync.py`.
 *  `backend/tests/core/test_zoho_sync_mirror.py` keeps the two equal. */

export const ZOHO_CONTACTS_SYNC_FLAG = "zoho_contacts_sync" as const;
export const ZOHO_SYNC_OBJECTS = ["contact", "account"] as const;
export type ZohoSyncObject = (typeof ZOHO_SYNC_OBJECTS)[number];
export const ZOHO_SYNC_DIRECTIONS = ["both", "from_zoho", "to_zoho"] as const;
export type ZohoSyncDirection = (typeof ZOHO_SYNC_DIRECTIONS)[number];
export const ZOHO_SYNC_DEFAULT_DIRECTION = "both" as const;
/** Facts the operator (or staff in Sagot) sets: they go to Zoho and never come back from it. */
export const ZOHO_SYNC_PROTECTED_FIELDS = ["customer_ref", "tier", "account_status"] as const;
export const ZOHO_SYNC_DEFAULT_MAPPING = {
  "contact.name": "Full_Name",
  "contact.email": "Email",
  "contact.job_title": "Title",
  "contact.organisation": "Account_Name",
  "account.name": "Account_Name",
  "account.industry": "Industry",
  "account.notes": "Description",
} as const;
/** `connection` of the sync settings when Zoho was connected without the Contacts and Accounts scopes: reconnect to grant them. */
export const ZOHO_SYNC_NEEDS_SCOPES = "needs_scopes" as const;
export const ZOHO_SYNC_API_NAME_PATTERN = "^[A-Za-z][A-Za-z0-9_]{0,63}$" as const;
export const ZOHO_SYNC_MAPPING_MAX = 20 as const;
export const ZOHO_SYNC_ERROR_CODES = ["not_connected", "needs_reconnect", "scope", "unavailable", "busy", "failed"] as const;
export type ZohoSyncErrorCode = (typeof ZOHO_SYNC_ERROR_CODES)[number];
